import { render, staticRenderFns } from "./NotifyStockModal.vue?vue&type=template&id=7c6b0663"
import script from "./NotifyStockModal.vue?vue&type=script&lang=js"
export * from "./NotifyStockModal.vue?vue&type=script&lang=js"
import style0 from "./NotifyStockModal.vue?vue&type=style&index=0&id=7c6b0663&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports